// firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCWRmI7n0mv60QYXBKQTONdZHVvWWxtVMA",
  authDomain: "vediverse.firebaseapp.com",
  projectId: "vediverse",
  storageBucket: "vediverse.appspot.com",
  messagingSenderId: "345926106957",
  appId: "1:345926106957:web:dbf681000a90144a870104",
  measurementId: "G-BC63EKP8HJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const storage = getStorage(app);

export const db = getFirestore(app);

// Google Login
const googleProvider = new GoogleAuthProvider();
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);

// Email/Password Login
export const signInWithEmail = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// Auth Listener
export const listenToAuthChanges = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Logout
export const logout = () => signOut(auth);

export default app;
